<template>
  <div>
    <div class="form-section">
      <h3>Đổi mật khẩu <br> TQC Tần Tử Anh</h3>
      <div class="login-inner-form">
        <form action="#" method="POST">          
          <div class="form-group form-box">
            <input type="text" name="account" class="input-text" readonly="readonly" v-model="user.account">
            <i class="flaticon-user"></i>
          </div>
          <div class="form-group form-box">
            <input type="password" name="password" v-model="password" class="input-text" placeholder="Mật khẩu cũ">
            <i class="flaticon-password"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="email" v-model="email" class="input-text" placeholder="Nhập Email">
            <i class="flaticon-mail"></i>
          </div>
          <div class="form-group form-box">
            <input type="password" name="new_password" v-model="new_password" class="input-text" placeholder="Mật khẩu mới">
            <i class="flaticon-password"></i>
          </div>
          <div class="form-group form-box">
            <input type="password" name="re_new_password" v-model="re_new_password" class="input-text" placeholder="Nhập lại mật khẩu mới">
            <i class="flaticon-password"></i>
          </div>

          <div class="form-group mb-0">
            <button type="button" @click="changePassword" class="btn-md btn-theme btn-block">Đổi Mật Khẩu</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'ChangePassword',
    components: {
    },
    props: {
      tqc_api: String,
      user: {},
      token: String
    },
    mounted() {
      this.$emit('get-info')
    },
    methods: {
      changePassword() {
        if (this.clicked) {
          return false
        }
        if (!this.validate()) {
          // alert('Có gì đó sai sai !')
          return false
        }

        this.clicked = true

        axios.put(`${this.tqc_api}update-password`, {
          token: this.token,
          email: this.email,
          password: this.password,
          new_pass: this.new_password,
        }).then(() => {
          this.clicked = false
          localStorage.token = ''
          localStorage.user = ''
          localStorage.daily = ''
          alert('Đổi mật khẩu thành công, vui lòng đăng nhập lại !')
          this.$router.push({
            name: 'Login'
          })
        }).catch(() => {
          this.clicked = false
          alert('Thông tin không chính xác !')
        })
      },
      validate() {
        if (this.email.length < 6) {
          alert('Email không được để trống !')
          return false
        }
        if (this.password.length < 6) {
          alert('Mật khẩu không được để trống !')
          return false
        }
        if (this.new_password.length < 6) {
          alert('Mật khẩu mới không được để trống !')
          return false
        }
        if (this.re_new_password.length < 6) {
          alert('Nhập lại mật khẩu mới không được để trống !')
          return false
        }
        if (this.re_new_password != this.new_password) {
          alert('Nhập lại mật khẩu không đúng !')
          return false
        }
        if (this.password == this.new_password) {
          alert('Mật khẩu mới phải khác mật khẩu cũ !')
          return false
        }
        return true
      }
    },
    data() {
      return {
        clicked: false,
        password: '',
        new_password: '',
        email: '',
        re_new_password: ''
      }
    }
  }
</script>
